var moduleMap = {
	"./ContractorManagement": () => {
		return Promise.all([__webpack_require__.e(221), __webpack_require__.e(169), __webpack_require__.e(256), __webpack_require__.e(212), __webpack_require__.e(950), __webpack_require__.e(69), __webpack_require__.e(576), __webpack_require__.e(313), __webpack_require__.e(92)]).then(() => (() => ((__webpack_require__(5279)))));
	},
	"./ContractorDetailsWrapper": () => {
		return Promise.all([__webpack_require__.e(221), __webpack_require__.e(169), __webpack_require__.e(212), __webpack_require__.e(950), __webpack_require__.e(69), __webpack_require__.e(576), __webpack_require__.e(13)]).then(() => (() => ((__webpack_require__(6574)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});